export const baseFonts = [

  // Open Sans family
  {
    name: 'Default', family: ['Open Sans', 'Open Sans', 'Roboto'], weight: ['400', '400', '400'],
  },
  {
    name: 'Elegant', family: ['Open Sans', 'Open Sans', 'Lato'], weight: ['400', '400', '400'],
  },
  {
    name: 'Elegant Sleek', family: ['Open Sans', 'Open Sans', 'Lato'], weight: ['300', '300', '300'],
  },
  {
    name: 'Worldly', family: ['Open Sans', 'Open Sans', 'Lato'], weight: ['400', '400', '400'],
  },
  {
    name: 'Generous', family: ['Open Sans', 'Open Sans', 'Raleway'], weight: ['400', '400', '400'],
  },
  {
    name: 'Useful', family: ['Open Sans', 'Open Sans', 'Source Sans Pro'], weight: ['400', '300', '400'],
  },

  // Open Sans Condensed family
  {
    name: 'Lighthearted', family: ['Josefin Slab', 'Open Sans Condensed', 'Open Sans Condensed'], weight: ['400', '300', '300'],
  },
  {
    name: 'Spirited', family: ['Amatic SC', 'Open Sans Condensed', 'Open Sans Condensed'], weight: ['400', '300', '300'],
  },
  {
    name: 'Fairy Tale', family: ['Sacramento', 'Open Sans Condensed', 'Open Sans Condensed'], weight: ['400', '300', '300'],
  },
  {
    name: 'Clear', family: ['Open Sans Condensed', 'Raleway', 'Raleway'], weight: ['300', '400', '400'],
  },

  // Roboto family
  {
    name: 'Standard', family: ['Roboto', 'Roboto', 'Roboto'], weight: ['700', '500', '400'],
  },
  {
    name: 'Standard Sleek', family: ['Roboto', 'Roboto', 'Roboto'], weight: ['400', '300', '300'],
  },
  {
    name: 'Pleasant', family: ['Roboto', 'Lato', 'Lato'], weight: ['400', '400', '400'],
  },
  {
    name: 'Ample', family: ['Roboto', 'Roboto', 'Raleway'], weight: ['400', '400', '400'],
  },
  {
    name: 'Stuffed', family: ['Roboto', 'Roboto', 'Oswald'], weight: ['400', '400', '400'],
  },
  {
    name: 'Airy', family: ['Roboto', 'Roboto', 'Montserrat'], weight: ['400', '400', '400'],
  },

  // Libre Baskerville family
  {
    name: 'Official', family: ['Playfair Display', 'Playfair Display', 'Libre Baskerville'], weight: ['400', '400', '400'],
  },
  {
    name: 'Decisive', family: ['Libre Baskerville', 'Libre Baskerville', 'Raleway'], weight: ['400', '400', '400'],
  },
  {
    name: 'Sociable', family: ['Lobster', 'Libre Baskerville', 'Libre Baskerville'], weight: ['400', '700', '400'],
  },
  {
    name: 'Frank', family: ['Josefin Slab', 'Libre Baskerville', 'Libre Baskerville'], weight: ['400', '400', '400'],
  },

  // Gravitas family
  {
    name: 'Strong', family: ['Gravitas One', 'Gravitas One', 'Open Sans'], weight: ['400', '400', '600'],
  },
  {
    name: 'Capable', family: ['Gravitas One', 'Gravitas One', 'Oswald'], weight: ['400', '400', '400'],
  },
  {
    name: 'Stable', family: ['Gravitas One', 'Roboto', 'Roboto'], weight: ['400', '500', '400'],
  },
  {
    name: 'Steady', family: ['Arvo', 'Arvo', 'Gravitas One'], weight: ['400', '400', '400'],
  },
  {
    name: 'Impactful', family: ['Lobster', 'Gravitas One', 'Gravitas One'], weight: ['400', '400', '400'],
  },


  // Oswald family
  {
    name: 'Snug', family: ['Oswald', 'Oswald', 'Open Sans'], weight: ['400', '300', '400'],
  },
  {
    name: 'Compact', family: ['Oswald', 'Oswald', 'Lato'], weight: ['400', '300', '400'],
  },
  {
    name: 'Cozy', family: ['Oswald', 'Oswald', 'Roboto'], weight: ['400', '300', '400'],
  },
  {
    name: 'Unofficial', family: ['Indie Flower', 'Oswald', 'Oswald'], weight: ['400', '400', '300'],
  },
  {
    name: 'Cushy', family: ['Oswald', 'Oswald', 'Raleway'], weight: ['400', '300', '400'],
  },

  // Arvo family
  {
    name: 'Systematic', family: ['Arvo', 'Arvo', 'Open Sans'], weight: ['700', '400', '400'],
  },
  {
    name: 'Analytical', family: ['Arvo', 'Arvo', 'Lato'], weight: ['400', '400', '400'],
  },
  {
    name: 'Disciplined', family: ['Arvo', 'Arvo', 'Roboto'], weight: ['700', '400', '400'],
  },
  {
    name: 'Orderly', family: ['Arvo', 'Oswald', 'Oswald'], weight: ['400', '500', '400'],
  },

  // Josefin Slab family
  {
    name: 'Folksy', family: ['Amatic SC', 'Josefin Slab', 'Josefin Slab'], weight: ['400', '400', '400'],
  },
  {
    name: 'Improv', family: ['Sacramento', 'Josefin Slab', 'Josefin Slab'], weight: ['400', '600', '400'],
  },
  {
    name: 'Unrestrained', family: ['Lobster', 'Josefin Slab', 'Josefin Slab'], weight: ['400', '600', '400'],
  },

  // PT family
  {
    name: 'Familiar', family: ['PT Serif', 'PT Sans', 'PT Sans'], weight: ['400', '700', '400'],
  },
  {
    name: 'Faithful', family: ['PT Sans', 'PT Sans', 'Roboto'], weight: ['400', '400', '400'],
  },
  {
    name: 'Sincere', family: ['PT Sans Caption', 'PT Sans Caption', 'PT Sans'], weight: ['700', '400', '400'],
  },
  {
    name: 'Safe', family: ['PT Sans', 'PT Sans', 'PT Sans Narrow'], weight: ['700', '400', '400'],
  },
  {
    name: 'Essential', family: ['PT Sans Caption', 'PT Sans Caption', 'PT Sans Narrow'], weight: ['400', '400', '400'],
  },
  {
    name: 'Dependable', family: ['PT Sans Narrow', 'PT Sans Narrow', 'PT Sans'], weight: ['400', '400', '400'],
  },

  // Playfair Display family
  {
    name: 'Harmonious', family: ['Playfair Display', 'Playfair Display', 'Raleway'], weight: ['400', '400', '400'],
  },
  {
    name: 'Cordial', family: ['Josefin Slab', 'Playfair Display', 'Playfair Display'], weight: ['400', '400', '400'],
  },

  // Cookie family
  {
    name: 'Trendy', family: ['Cookie', 'Playfair Display', 'Playfair Display'], weight: ['400', '700', '400'],
  },
  {
    name: 'Groovy', family: ['Cookie', 'Raleway', 'Raleway'], weight: ['400', '700', '400'],
  },
  {
    name: 'Nifty', family: ['Cookie', 'Open Sans Condensed', 'Open Sans Condensed'], weight: ['400', '700', '300'],
  },

  // Lobster family
  {
    name: 'Hearty', family: ['Lobster', 'Lobster', 'Cookie'], weight: ['400', '400', '400'],
  },
  {
    name: 'Intrinsic', family: ['Lobster', 'Play', 'Play'], weight: ['400', '700', '400'],
  },
  {
    name: 'Relaxed', family: ['Lobster', 'Raleway', 'Raleway'], weight: ['400', '600', '400'],
  },

  // Ubuntu family
  {
    name: 'Contemporary', family: ['Ubuntu', 'Ubuntu', 'Raleway'], weight: ['400', '400', '400'],
  },
  {
    name: 'Integral', family: ['Ubuntu', 'Ubuntu', 'Oswald'], weight: ['400', '400', '400'],
  },
  {
    name: 'Prevalent', family: ['Ubuntu', 'Ubuntu', 'Open Sans'], weight: ['400', '400', '400'],
  },

];



// WEBPACK FOOTER //
// ./scripts/components/editor/fonts.js